import { FileUploaderStore } from "../../../store/store_state";

const useDragAndDropFileModal = () => {
  const selectedFiles = FileUploaderStore.useState((s) => s.selectedFiles);

  return { selectedFiles };
};

export default useDragAndDropFileModal;
